import { render, staticRenderFns } from "./ClusterLink.vue?vue&type=template&id=ebf36e78&scoped=true&"
import script from "./ClusterLink.vue?vue&type=script&lang=js&"
export * from "./ClusterLink.vue?vue&type=script&lang=js&"
import style0 from "./ClusterLink.vue?vue&type=style&index=0&id=ebf36e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf36e78",
  null
  
)

export default component.exports